import 'es6-promise/auto'
import "isomorphic-fetch"

import Vue from 'vue'
import ElementUI from 'element-ui'

import moment from 'moment'
import './wta-theme.scss'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import Vuex from 'vuex'
import TournamentLevelPlugin from './plugins/tournament-level'

import store from './store';
import { default as msalPlugin } from 'vue-msal-browser';
import axios from 'axios';

Vue.prototype.moment = moment
moment.defaultFormat = 'DD MMM YYYY - HH:mm A'

require('moment-timezone')

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

Vue.filter('toEnumeration', function (i) {
    if (typeof i !== "number") {
        return i;
    }
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
});

Vue.filter('toNumber', function (i) {
    if (typeof i === "number") {
        return i;
    }
    if (i === 'First') {
        return 1;
    }
    if (i === 'Second') {
        return 2;
    }
    if (i === 'Third') {
        return 3;
    }
    return 4;
});

Vue.filter('spaceBeforeCap', function (string) {
    string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
    string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    return string;
});

Vue.filter('fromWithin', function (i) {
    if (typeof i === "number") {
        return i;
    }
    if (i === 'Top1Alternate') {
        return 1;
    }
    if (i === 'Top2Alternates') {
        return 2;
    }
    if (i === 'Top3Alternates') {
        return 3;
    }
    if (i === 'Top4Alternates') {
        return '-';
    }
    return '-';
});

locale.use(lang)

var App = undefined;
if (USE_LISTS) {
    App = require('./AppAllAcceptanceLists.vue')
} else if (USE_ENTRY) {
    App = require('./AppMicrositeEntry.vue')
} else {
    App = require('./App.vue')
}
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(TournamentLevelPlugin)
Vue.use(Autocomplete)

import LogRocket from 'logrocket';
LogRocket.init('dns08a/wta-logrocket');

const msalConfig = {
    auth: {
        tenant: 'ccebfe25-c6c1-436a-997d-5480160770b1',
        clientId: 'd7ce8657-6c47-45ed-9e7c-5a1eec2eeef2',
        authority: 'https://login.microsoftonline.com/ccebfe25-c6c1-436a-997d-5480160770b1',
        redirectUri: process.env.VUE_APP_AD_CALLBACK_URL,
        scopes: ['openid'],
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    mode: 'redirect',
};
Vue.use(msalPlugin, msalConfig);

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwt');
    const accessToken = localStorage.getItem('accessToken');
    if (config === undefined) {
        config = { headers: {} }
    }
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['X-Access-Token'] = `Bearer ${accessToken}`;
    return config;
});

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
    let [resource, config] = args;

    if (resource.startsWith('http://127.0.0.1') || resource.startsWith('https://uat.blstaging') || resource.startsWith('https://live.baseline')) {
        const token = localStorage.getItem('jwt');
        const accessToken = localStorage.getItem('accessToken');
        if (config === undefined) {
            config = {
                headers: new Headers()
            }
        }
        if (config.headers !== undefined) {
            config.headers.set('Authorization', `Bearer ${token}`);
            config.headers.set('X-Access-Token', `Bearer ${accessToken}`);
        } else {
            config.headers = new Headers({
                'Cache': 'no-cache',
                'Authorization': `Bearer ${token}`,
                'X-Access-Token': `Bearer ${accessToken}`,
            })
        }
    }

    return await originalFetch(resource, config);
};

new Vue({
    el: '#app',
    store,
    render: h => h(App.default)
})

// eslint-disable-next-line no-console
console.log('Using environment: ', process.env.NODE_ENV);

// eslint-disable-next-line no-console
console.log('Using API URL: ', process.env.VUE_APP_API_URL);

// eslint-disable-next-line no-console
console.log('Using AD Callback URL: ', process.env.VUE_APP_AD_CALLBACK_URL);



// WEBPACK FOOTER //
// ./src/main.js